module.exports = __webpack_public_path__ + "static/media/cimb.4b5f80b0.jpg";